module.exports = __webpack_public_path__ + "static/media/gred-image3.a1d4daf4.png";